function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0312 26.7966H10.3906V13.9013C10.407 10.5052 10.9375 4.40755 16.7289 3.07318C18.7633 2.60287 20.4258 2.88724 21.793 3.91537C24.3906 5.86224 24.5766 9.52084 24.5875 9.6849V20.7755H22.9688V9.99115C22.9688 9.99115 22.6844 6.75365 20.7375 5.30443C19.7969 4.59896 18.5227 4.41849 17.0133 4.76849C14.6234 5.32084 13.1797 6.8849 12.4414 9.57006C11.8562 11.6919 12.1078 13.9451 12.0312 13.863V26.7966Z",
  fill: "#043E7D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.79736 21.1534L28.6794 14.7495L32.3872 15.9745L36.7239 15.6409L15.4122 21.7331L4.79736 21.1534Z",
  fill: "#043E7D"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.1437 66.1011L11.593 64.1159C11.2648 64.0011 10.9094 63.9846 10.5758 64.0722L6.40312 65.1659C5.61016 65.3737 4.82812 64.7722 4.82812 63.9518V21.0604L13.0148 20.694C13.2172 20.6831 13.4195 20.7268 13.6055 20.8198L15.4102 21.7331L17.1437 66.1011Z",
  fill: "#043E7D"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4106 21.7331V64.362C15.4106 65.5651 16.5974 66.4018 17.7294 66.0026L35.563 59.6807C35.9021 59.5606 36.1957 59.3384 36.4033 59.0446C36.611 58.7508 36.7224 58.3999 36.7224 58.0401V15.6135L15.4106 21.7331Z",
  fill: "#16202C"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1418 28.4374H17.5012V16.5428C17.5012 16.2038 17.4355 13.4694 18.1301 10.5381C19.1418 6.28892 21.466 3.7022 24.7637 3.06236C27.0988 2.60845 29.0074 2.98579 30.391 4.19439C32.8793 6.36001 32.7043 10.3413 32.6934 10.5108L32.7098 25.1561H31.173V10.478C31.173 10.4014 31.2168 7.09283 29.3684 5.49048C28.4059 4.65923 26.9676 4.41314 25.1902 4.75767C18.841 5.99361 19.1363 16.4061 19.1418 16.5155V28.4374Z",
  fill: "#16202C"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M31.1292 31.4011L23.1558 33.9495C22.9742 34.0021 22.7829 34.0117 22.597 33.9777C22.411 33.9436 22.2356 33.8668 22.0844 33.7533C21.9333 33.6398 21.8106 33.4927 21.726 33.3237C21.6415 33.1546 21.5973 32.9683 21.5972 32.7792V30.7175C21.5972 30.1761 21.9581 29.6949 22.4776 29.5472L30.4511 26.9988C30.6326 26.9462 30.8239 26.9366 31.0099 26.9706C31.1958 27.0047 31.3713 27.0815 31.5224 27.195C31.6736 27.3085 31.7963 27.4556 31.8808 27.6246C31.9654 27.7937 32.0095 27.9801 32.0097 28.1691V30.2308C32.0097 30.7722 31.6487 31.248 31.1292 31.4011Z",
  fill: "#043E7D"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M63.4864 65.9584H33.288C31.8825 65.9584 30.5864 65.0725 30.5864 63.667V25.2053H66.1716V63.667C66.1716 65.0725 64.8919 65.9584 63.4864 65.9584Z",
  fill: "#B1201E"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M66.1457 56.4102V63.6563C66.1457 65.0672 64.866 65.9531 63.4551 65.9531H33.2621C31.8566 65.9531 30.5605 65.0672 30.5605 63.6563V56.4102H66.1457Z",
  fill: "#FE5755"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M30.5864 19.3757H66.1606V25.2054H30.5864V19.3757Z",
  fill: "#522121"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M33.1063 20.8358L34.5117 21.6506C35.0094 21.9405 35.0094 22.6569 34.5117 22.9467L33.1117 23.7561L30.5852 25.2108L30.5797 22.296L30.5742 19.3811L33.1063 20.8358Z",
  fill: "#BE1B19"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M63.6342 20.8358L62.2342 21.6452C62.1195 21.7114 62.0242 21.8067 61.958 21.9214C61.8918 22.0361 61.8569 22.1662 61.8569 22.2987C61.8569 22.4311 61.8918 22.5613 61.958 22.676C62.0242 22.7907 62.1195 22.886 62.2342 22.9522L63.6287 23.7561L66.1553 25.2108L66.1607 22.296L66.1662 19.3811L63.6342 20.8358Z",
  fill: "#BE1B19"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M58.8972 19.5999H57.0761V14.5194C57.0761 9.70693 53.144 5.78584 48.3097 5.78584C43.4753 5.78584 39.5433 9.70146 39.5433 14.5194V19.5999H37.7222V14.5194C37.7222 8.70068 42.469 3.97021 48.3097 3.97021C54.1503 3.97021 58.8972 8.70068 58.8972 14.5194V19.5999Z",
  fill: "#522121"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4062 58.368V56.5633L30.5656 51.4446V53.2329L15.4062 58.368Z",
  fill: "#043E7D"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M33.2227 25.2H35.9297V56.4101H33.2227V25.2Z",
  fill: "#FE5755"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M44.2246 25.2H46.9316V56.4101H44.2246V25.2Z",
  fill: "#FE5755"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M49.7271 25.2H52.4341V56.4101H49.7271V25.2Z",
  fill: "#FE5755"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M55.23 25.2H57.937V56.4101H55.23V25.2Z",
  fill: "#FE5755"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M38.7251 25.2H41.4321V56.4101H38.7251V25.2Z",
  fill: "#FE5755"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M60.7295 25.2H63.4365V56.4101H60.7295V25.2Z",
  fill: "#FE5755"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M58.4009 29.7282H56.6673V19.6657C56.6673 15.0774 52.9157 11.3422 48.311 11.3422C43.7063 11.3422 39.9548 15.0774 39.9548 19.6657V29.7336H38.2212V19.6657C38.2212 14.1204 42.7493 9.60864 48.311 9.60864C53.8728 9.60864 58.4009 14.1204 58.4009 19.6657V29.7282Z",
  fill: "#BE1B19"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M38.9879 31.9975C39.8668 31.9975 40.5793 31.285 40.5793 30.4061C40.5793 29.5272 39.8668 28.8147 38.9879 28.8147C38.109 28.8147 37.3965 29.5272 37.3965 30.4061C37.3965 31.285 38.109 31.9975 38.9879 31.9975Z",
  fill: "#BE1B19"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M57.4863 32.0469C58.3924 32.0469 59.127 31.3123 59.127 30.4062C59.127 29.5002 58.3924 28.7656 57.4863 28.7656C56.5802 28.7656 55.8457 29.5002 55.8457 30.4062C55.8457 31.3123 56.5802 32.0469 57.4863 32.0469Z",
  fill: "#BE1B19"
});

function SvgShoppingBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shoppingBag.b4bb766e.svg";
export { ForwardRef as ReactComponent };